import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var ControllerRecord = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M16 32a16 16 0 1116-16 16 16 0 01-16 16zm0-30a14 14 0 1014 14A14 14 0 0016 2zm0 20.87A6.87 6.87 0 1122.87 16 6.88 6.88 0 0116 22.87zm0-11.74A4.87 4.87 0 1020.87 16 4.88 4.88 0 0016 11.13z" })), '0 0 32 32', 'ControllerRecord');
//# sourceMappingURL=ControllerRecord.js.map